module.exports = __webpack_public_path__ + "img/icon-track-light-horizontal.e5119e28.svg";